import { Pipe, PipeTransform } from '@angular/core';
import { BindObjectValuePipe } from './bind-object-value.pipe';

@Pipe({
  name: 'filterByKeyAndValue'
})
export class FilterByKeyAndValuePipe implements PipeTransform {

  transform(array: any[], key: string, value: any): any[] {
    
    if (!value) {
      return array;
    }
    return array?.filter(item => {
      let compare_value = new BindObjectValuePipe().transform(item, key);
      return compare_value == value
    })
  }
}
